import { render, staticRenderFns } from "./IssuetrackingCreatesplit.vue?vue&type=template&id=6e764daa"
import script from "./IssuetrackingCreatesplit.vue?vue&type=script&lang=js"
export * from "./IssuetrackingCreatesplit.vue?vue&type=script&lang=js"
import style0 from "./IssuetrackingCreatesplit.vue?vue&type=style&index=0&id=6e764daa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports